module.exports = __webpack_public_path__ + "packs/media/images/Herz-8e7a3e55d7389e3a413f3c5b77ee09b0.png";